export enum ConsentType {
  VetcoClinicsWellness = 1,
  TreatmentPlanConsent = 2,
  DischargeAgainstMedicalAdviceConsent = 3,
  ClientConsent = 4,
  DentalExtractionsConsent = 5,
  EuthanasiaConsent = 6,
  TreatmentConsent = 7,
  SurgeryConsent = 8,
}

export const HospitalConsents = [
  ConsentType.TreatmentPlanConsent,
  ConsentType.DischargeAgainstMedicalAdviceConsent,
  ConsentType.ClientConsent,
  ConsentType.DentalExtractionsConsent,
  ConsentType.EuthanasiaConsent,
  ConsentType.TreatmentConsent,
  ConsentType.SurgeryConsent,
];
